import request from '@/axios'

// 昨日回顾
export function getReviewMsg(data) {
  return request({
    url: '/inside/home/push/reviewMsg',
    data
  })
}

// 找线索
export function getFindMsg(data) {
  return request({
    url: '/inside/home/push/findMsg',
    data
  })
}

// 跟进复盘
export function getFollowMsg(data) {
  return request({
    url: '/inside/home/push/followMsg',
    data
  })
}

// 学习成长
export function getTrainingMsg(data) {
  return request({
    url: '/inside/home/push/trainingMsg',
    data
  })
}

// 已读操作
export function hasRead(data) {
  return request({
    url: '/inside/home/push/read',
    data
  })
}

// 获取轮播数据
export function getWorkProgressList(data) {
  return request({
    url: '/inside/ai/meetingTrainInfo/getWorkProgressList',
    data
  })
}

// 获取轮播数据详情
export function getWorkProgressDetailList(data) {
  return request({
    url: '/inside/ai/meetingTrainInfo/getWorkProgressDetailList',
    data
  })
}

// 获取日程列表
export function getScheduleList(data) {
  return request({
    url: '/inside/schedule/list',
    data
  })
}

// 获取推荐任务列表
export function getRecommendedList(data) {
  return request({
    url: '/inside/recommended/list',
    data
  })
}

// 获取推荐任务内部列表
export function getRecommendedTaskList(data) {
  return request({
    url: '/inside/recommended/list/tasks',
    data
  })
}

// 忽略操作
export function ignorePlan(data) {
  return request({
    url: '/inside/recommended/ignore/plan',
    data
  })
}
